import { render, staticRenderFns } from "./JpjkIndex.vue?vue&type=template&id=377252de&scoped=true&"
import script from "./JpjkIndex.vue?vue&type=script&lang=js&"
export * from "./JpjkIndex.vue?vue&type=script&lang=js&"
import style0 from "./JpjkIndex.vue?vue&type=style&index=0&id=377252de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377252de",
  null
  
)

export default component.exports